import { render, staticRenderFns } from "./CommunicationSettingsView.vue?vue&type=template&id=0d964ad8"
import script from "./CommunicationSettingsView.ts?vue&type=script&lang=ts&external"
export * from "./CommunicationSettingsView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports